import React from "react";

export const Biographies = React.lazy(() =>
  import("./Biographies/index"),
);
export const ReportBiographics = React.lazy(() =>
  import("./ReportedBiographies/index"),
);